import { Component } from '@angular/core';
import { FaqCardComponent } from './faq-card/faq-card.component';
import { NgFor } from '@angular/common';

@Component({
  selector: 'app-faq',
  standalone: true,
  imports: [FaqCardComponent, NgFor],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss'
})
export class FaqComponent {
  FAQs = [
    {
      question: 'What is MAC 76B25?',
      answer: `MAC 76B25 is a Phygital Gallery, crafting a multifunctional space that showcases the finest in contemporary 
      art and serves as a bridge between the tangible and the digital realms of creativity.<br><br>
      MAC 76B25 is built on top of Fermion Protocol tech: all physical Artworks in the Gallery are tokenized as a RWA NFT.`
    },
    {
      question: 'Where is MAC 76B25?',
      answer: `MAC 76B25 is located at Via Mecenate 76/B, Milan, Italy.`
    },
    {
      question: 'How can I purchase an Artwork?',
      answer: `The Works exhibited in MAC 76B25 are not currently available for public purchase.<br> 
      To get informations about a Work, contact us at info@mecenateartcorner.com`
    },
    {
      question: 'What are RWAs?',
      answer: `Real World Assets (RWAs) are tangible or intangible assets that exist outside of the digital realm, such as real estate, commodities, stocks, bonds and art.<br><br>
      Each one of these assets can be "<i>tokenized</i>" on-chain, unlocking endless possibilities for the users.`
    },
    {
      question: 'How does Fermion work?',
      answer: `Fermion Protocol is an innovative system - built on top of Boson Protocol - created to incentivize the tokenization 
      of all verified physical assets in a fragmented and on-chain market.<br><br>
      It works by involving trusted verifiers and custodians to enable a more robust verification and a decentralized exchange 
      infrastructure for Real World Assets such as real estate, art, and luxury items. For more detailed info, check the 
      Fermion Protocol <a href="https://docsend.com/view/qaw5vbwcifebeufc" target="_blank">lightpaper</a>.`
    }
  ]
}
